import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import RawMaterialService from '../services/RawMaterialService';
import { isEmpty } from 'lodash';
import UomConversionService from '../services/UomConversionService';

const initialState = {
  data: [],
  datas: [],
  parent_datas: [],
  formError: [],
  pagination: {
    page: 0,
    per_page: 10,
    total: 10,
    totalPages: 10,
  },
  error: null,
  isSuccess: false,
  loading: false,
  submitLoading: false,
};

export const fetchUomConversionList = createAsyncThunk(
  'conversion/fetchUomConversionList',
  async ({ perPage, page, keyword, type = '' }) => {
    try {
      const resp = await UomConversionService.FetchUomConversionList({ perPage, page, keyword, type });
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

export const createUomConversion = createAsyncThunk('conversion/createUomConversion', async (data, { rejectWithValue }) => {
  try {
    const resp = await UomConversionService.CreateUomConversion(data);
    return resp;
  } catch (error) {
    return rejectWithValue(error.response);
  }
});

export const updateUomConversion = createAsyncThunk('conversion/updateUomConversion',
  async (payload, { rejectWithValue }) => {
    try {
      const resp = await UomConversionService.UpdateUomConversion(payload);
      return resp;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

const conversionSlice = createSlice({
  name: 'conversion',
  initialState: initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchUomConversionList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchUomConversionList.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data.data?.uomConversionList];
          state.pagination = action.payload?.data.data?.pagination;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(fetchUomConversionList.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.loading = false;
      })
      .addCase(createUomConversion.pending, (state, action) => {
        state.submitLoading = true;
        state.formError = [];
        state.isSuccess = false;
      })
      .addCase(createUomConversion.fulfilled, (state, action) => {
        state.datas.unshift(action.payload.data.data);
        toast.success(action.payload?.message);
        state.pagination = {
          ...state.pagination,
          total: state.pagination.total + 1,
        };
        state.submitLoading = false;
        state.isSuccess = true;
      })
      .addCase(createUomConversion.rejected, (state, action) => {
        const errors = action.payload?.data.errors;
        state.submitLoading = false;
        state.isSuccess = false;
        if (isEmpty(errors)) {
          toast.error(action.payload?.data.message || 'Something went wrong');
        } else {
          state.formError = errors;
        }
      })
      .addCase(updateUomConversion.pending, (state, action) => {
        state.info = '';
        state.submitLoading = true;
        state.isSuccess = false;
      })
      .addCase(updateUomConversion.fulfilled, (state, action) => {
        const index = state.datas.findIndex((client) => client.id === action.payload.data.data.id);
        state.datas[index] = {
          ...state[index],
          ...action.payload.data.data,
        };
        toast.success(action.payload?.data.message);
        state.submitLoading = false;
        state.isSuccess = true;
      })
      .addCase(updateUomConversion.rejected, (state, action) => {
        state.submitLoading = false;
        const errors = action.payload?.data?.errors;
        state.isSuccess = false;
        if (isEmpty(errors)) {
          toast.error(action.payload?.data.message || 'Something went wrong');
        } else {
          state.formError = errors;
        }
      })
  },
});

const { reducer } = conversionSlice;


export const conversionSelector = (state) => state?.conversion;

export default reducer;
